import { render } from "./StatusCanceled.svg?vue&type=template&id=8a01ce90"
const script = {}
script.render = render

export default script